module.exports = __webpack_public_path__ + "img/login_bg.f0cb3b4a.png";